/**
 * Initial state of the municipality picker
 */
export default {
    selectedCounty: null,
    highlightedCounty: null,
    highlightedMunicipality: null,
    query: '',
    data: [],
    offset: 0,
}



// WEBPACK FOOTER //
// ./scripts/web-components/municipality-picker/state.js